import React from 'react';
import type { GoodsOption } from 'shared/src/api';
import { Flex, List, PrimaryButton, VerticalSpacing } from '@banhala/ui-kit';
import { PricingListItem } from './PricingListItem';
import { PricingInfo } from './PricingInfo';
import { useIsBottomSheetGiftMode } from '../../hooks/useIsBottomSheetGiftMode';
import { useOnPressPurchase } from '../../hooks/useOnPressPurchase';
import { useOnPressAddToCart } from '../../hooks/useOnPressAddToCart';
import { ReportPriceButton } from './ReportPriceButton';

export const PricingListView: React.FC<{
  selected: GoodsOption[];
  onUpdateOption: (option: GoodsOption) => void;
  onSelectMore: () => void;
  onPressDelete: (option: GoodsOption) => void;
  onCompleteAddToCart: () => void;
  onCompletePurchase: () => void;
  onAnonymouseUserPressedPurchase: () => void;
}> = props => {
  const { onPressPurchase, loadingProductCheckout } = useOnPressPurchase({
    selected: props.selected,
    onCompletePurchase: props.onCompletePurchase,
    onAnonymouseUserPressedPurchase: props.onAnonymouseUserPressedPurchase,
  });
  const { onPressAddToCart, loadingAddToCart } = useOnPressAddToCart({
    selected: props.selected,
    onCompleteAddToCart: props.onCompleteAddToCart,
  });
  const isGiftMode = useIsBottomSheetGiftMode();

  return (
    <Flex flex={1}>
      <List<GoodsOption>
        ListHeaderComponent={
          isGiftMode ? undefined : (
            <Flex>
              <PrimaryButton
                variant={'fill'}
                outline
                size={'large'}
                onPress={props.onSelectMore}
              >
                옵션 선택하기
              </PrimaryButton>
              <VerticalSpacing size={12} />
            </Flex>
          )
        }
        style={{ flex: 1 }}
        contentContainerStyle={{
          paddingVertical: 16,
          paddingHorizontal: 16,
        }}
        data={props.selected}
        ItemSeparatorComponent={() => <VerticalSpacing size={12} />}
        renderItem={({ item }) => {
          return (
            <PricingListItem
              option={item}
              onUpdateOption={props.onUpdateOption}
              onPressDelete={() => props.onPressDelete(item)}
            />
          );
        }}
        ListFooterComponent={<ReportPriceButton />}
      />
      <PricingInfo selected={props.selected} />
      {isGiftMode ? (
        <Flex.Row
          padding={{ horizontal: 12, vertical: 12 }}
          borderColor={'border_tertiary'}
          borderTopWidth={1}
          gap={8}
        >
          <Flex flex={1}>
            <PrimaryButton
              variant={'fill'}
              size={'xlarge'}
              onPress={onPressPurchase}
              state={loadingProductCheckout ? 'loading' : undefined}
            >
              선물하기
            </PrimaryButton>
          </Flex>
        </Flex.Row>
      ) : (
        <Flex.Row
          padding={{ horizontal: 12, vertical: 12 }}
          borderColor={'border_tertiary'}
          borderTopWidth={1}
          gap={8}
        >
          <Flex flex={1}>
            <PrimaryButton
              variant={'fill'}
              size={'xlarge'}
              outline={true}
              onPress={() => onPressAddToCart(false)}
              state={loadingAddToCart ? 'loading' : undefined}
            >
              장바구니
            </PrimaryButton>
          </Flex>
          <Flex flex={1}>
            <PrimaryButton
              variant={'fill'}
              size={'xlarge'}
              onPress={onPressPurchase}
              state={loadingProductCheckout ? 'loading' : undefined}
            >
              구매하기
            </PrimaryButton>
          </Flex>
        </Flex.Row>
      )}
    </Flex>
  );
};
